//Detect which section is in viewport
$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop <= viewportTop;
};



function smoothScroll(e){
  $('html, body').stop().animate({
        scrollTop: $( $(this).attr('href') ).offset().top
    }, 600);
}

//Run everything to generate sections 
function generateSections() {
	//change header color nav based on what's on viewport
	$('section.full-page').each(function() {
		var activeSection = $(this).attr('id');

		if ($(this).isInViewport()) {

			//set target for next section button
			var nextSection = $(this).nextAll('section:visible').eq(0).attr('id');
			// console.log(nextSection);
			if (nextSection == null) {
				$(".next-section-arrow").addClass('d-none');
			} else {
				$(".next-section-arrow").removeClass('d-none').attr('href', '#'+nextSection).on('click', smoothScroll );
			}


			//Set active class for dots
			//$('#dot-' + activeSection).addClass('active');

			//Set class for header
			var activeHeader = $(this).data('header');
			if (!$("header").hasClass(activeHeader)) {
				$("header").removeClass().addClass(activeHeader)
			};

		} else {

			// remove active class from dots	
		    //$('#dot-' + activeSection).removeClass('active');
		}
	});

}

//portrair or landscape?
function checkWindowRatio() {
	if((window.innerWidth / window.innerHeight) <= 1.4){
      $("body").addClass('portrait');
    } else {
       $("body").removeClass('portrait');
    }
}

//For hiding menu
var prevScrollpos = window.pageYOffset;
var menuHidePos = 300;

$(document).ready(function() {

	generateSections();
	checkWindowRatio();

	// Init ScrollMagic only on desktop
	if (window.innerWidth >= 992) { // Standard desktop breakpoint
		var ctrl = new ScrollMagic.Controller();

		$(".project-listing-desktop").each(function() {
			new ScrollMagic.Scene({triggerElement: this, duration: "200%", triggerHook: "onEnter"})
				.setTween(this, {backgroundPositionY: "100%", ease: Linear.easeNone})
				.addTo(ctrl);
		});
		$(".project-hero-desktop").each(function() {
			new ScrollMagic.Scene({triggerElement: ".project-hero", duration: "200%", triggerHook: "onLeave"})
				.setTween(this, {top: "-20%", ease: Linear.easeNone})
				.addTo(ctrl);
		});
		$("#image-1.project-image").each(function() {
			new ScrollMagic.Scene({triggerElement: this, triggerHook: "onEnter"})
				.setClassToggle(".project-desc .page-inner", 'fixed')
				.addTo(ctrl);
		});
	}
    

});


$(window).on('resize scroll', function() {
    //change header color  based on what's on viewport
	generateSections();
	
	//Hide menu when scrolling down
	var currentScrollPos = window.pageYOffset;
	if (currentScrollPos > menuHidePos) {
		if (prevScrollpos > currentScrollPos) {
		    $(".navbar").removeClass("hide");
		} else {
		   $(".navbar").addClass("hide");
		}
	}
	prevScrollpos = currentScrollPos;
	
});

$(window).on('resize', function() {
	 checkWindowRatio()
});

// Mobile main menu
$('#main-menu').on('show.bs.collapse', function () {
	$('body').addClass('menu-open');
	$("body.menu-open").on('click', function(e){
  		if(e.target.id == "main-menu")
  			return;
			$('#main-menu').collapse('hide');
	});
})

$('#main-menu').on('hide.bs.collapse', function (event) {
  $('body').removeClass('menu-open').off('click');
})
